import { useMemo } from "react";
import type { ChargeLayer } from "@/pages/sy/models/ChargeLayer";
import type { RecipeLayer } from "@/pages/sy/models/RecipeLayer";
import { calculateRequestedWeightLayerSuggestions } from "../utils/heatWeightScaling";

export const useRequestedWeightLayerSuggestions = ({
  recipeLayers,
  chargeLayers,
  scaledTargetWeight,
}: {
  recipeLayers: RecipeLayer[];
  chargeLayers: ChargeLayer[];
  scaledTargetWeight: number | null | undefined;
}) => {
  return useMemo(
    () =>
      scaledTargetWeight == null
        ? null
        : calculateRequestedWeightLayerSuggestions(
            recipeLayers,
            chargeLayers,
            scaledTargetWeight,
          ),
    [chargeLayers, recipeLayers, scaledTargetWeight],
  );
};
